import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AlertListRequest,
  AlertListTableItem,
  CompAlertStatus,
  UpdateAlertStatusRequest,
} from '@/api';
import { ComplianceAlertsData } from '../models';

export interface ComplianceAlertsSliceState {
  data: ComplianceAlertsData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceAlertsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceAlertsSlice = createSlice({
  name: 'complianceAlerts',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceAlertsData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    listAlerts: (state, action: PayloadAction<AlertListRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    updateStatus: (state, action: PayloadAction<UpdateAlertStatusRequest>) => ({
      ...state,
      error: null,
      loading: true,
    }),
    refreshAlertStatus: (
      state,
      action: PayloadAction<{ id: string; status: CompAlertStatus }>,
    ) => {
      if (state.data?.entries) {
        const currentItems: AlertListTableItem[] = JSON.parse(
          JSON.stringify(state.data?.entries || []),
        );
        const newItems = [...currentItems];

        if (action.payload) {
          const itemIndex = currentItems.findIndex(
            (item) => item.id === action.payload.id,
          );

          if (itemIndex !== -1) {
            const item = currentItems[itemIndex];
            item.state = action.payload.status;
            newItems.splice(itemIndex, 1, item);
          }
        }

        state.data.entries = newItems;
      }
    },
  },
});

export { complianceAlertsSlice };
